module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "wrap-black text-center"
  }, [_vm._c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn-pub btn-pub-primary btn-pub-borderless",
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    }
  }, [_vm._v("Continue To Dashboard")]), _vm._v(" "), _vm._c('p', {
    staticClass: "xs-pt-50"
  }, [_vm._v("\n      We've sent you an email confirmation for your account,"), _vm._c('br'), _vm._v("\n      if you haven't received it in your inbox "), _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'contact-us'
      }
    }
  }, [_vm._c('strong', [_vm._v("please let use know")])]), _vm._v("!\n    ")], 1), _vm._v(" "), _vm._c('p', [_vm._v("\n      Our service is free and we look forward to hearing any "), _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'contact-us'
      }
    }
  }, [_vm._c('strong', [_vm._v("feedback")])]), _vm._v(" you have.\n    ")], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('p', {
    staticClass: "xs-pb-30 text-larger"
  }, [_vm._v("\n      Thank You For Signing Up With CLEX!\n      "), _vm._c('br'), _vm._v("\n      You Are Now One Step Away From Starting Your Learning Experience.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-099caa84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/signup/Success.vue
// module id = 617
// module chunks = 1